import { useParams } from 'react-router-dom'
import { QuestSymbol } from 'state/vvsgotchi/models'
import useGotchiQuests from 'state/vvsgotchi/hooks/useGotchiQuests'
import PageLoading from 'views/VvsGotchi/components/PageLoading'

import MoleDashQuestDetailPage from 'views/VvsGotchi/MoleDashGame/QuestDetailPage'

import DefaultQuestDetailPage from './Default'

const QuestDetailPage: React.FC = () => {
  const { questId } = useParams<{ questId: string }>()
  const { loading, findQuest } = useGotchiQuests()
  const quest = findQuest(questId)

  if (!quest && loading) {
    return <PageLoading />
  }

  switch (quest?.symbol) {
    case QuestSymbol.MOLE_DASH:
      return <MoleDashQuestDetailPage quest={quest} />

    default:
      return <DefaultQuestDetailPage quest={quest} />
  }
}

export default QuestDetailPage
